import styled from 'styled-components'

interface Props {
  name: string
  checked: boolean
  disabled?: boolean
  label?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  register?: (instance: any) => void
}

export default function Checkbox({ name, checked, disabled = false, label, onChange, register }: Props): JSX.Element {
  const elementId = Math.random().toString(36).substring(7)
  const InputElement = disabled ? DisabledInput : Input
  return (
    <CheckboxContainer>
      <InputElement
        type="checkbox"
        name={name}
        {...(register ? register(name) : {})}
        checked={checked}
        id={elementId}
        onChange={onChange}
        disabled={disabled}
      />
      {label && <label htmlFor={elementId}>{label}</label>}
    </CheckboxContainer>
  )
}

const CheckboxContainer = styled.div`
  height: 30px;
  margin-top: 5px;

  & label {
    margin-left: 10px;
    line-height: 24px;
    cursor: pointer;
  }
`

const Input = styled.input`
  appearance: none;
  border: 2px solid;
  border-color: ${(props) => props.theme.palette.primary.main};
  border-radius: 3px;
  width: 24px;
  height: 24px;
  content: none;
  outline: none;
  margin: 0;
  cursor: pointer;
  position: relative;

  &:checked {
    appearance: none;
    outline: none;
    padding: 0;
    content: none;

    &::before {
      position: absolute;
      left: -10%;
      top: 40%;
      height: 40%;
      width: 3px;
      background-color: ${(props) => props.theme.palette.primary.main};
      content: '';
      transform: translateX(10px) rotate(-45deg);
      transform-origin: left bottom;
    }

    &::after {
      position: absolute;
      left: -10%;
      bottom: 20%;
      height: 3px;
      width: 70%;
      background-color: ${(props) => props.theme.palette.primary.main};
      content: '';
      transform: translateX(10px) rotate(-45deg);
      transform-origin: left bottom;
    }
  }
`

const DisabledInput = styled(Input)`
  border-color: ${(props) => props.theme.customPalette.mediumGray};
  pointer-events: none;
  && {
    &::before {
      background-color: ${(props) => props.theme.customPalette.mediumGray};
    }

    &::after {
      background-color: ${(props) => props.theme.customPalette.mediumGray};
    }
  }
`
